<section class="information" *ngIf="showSection">
    <div class="information__container">
        <div class="information__image-container infoimage">
            <img [src]="mainImageURL" alt="Information Image" class="information__image">
        </div>
        <div class="information__main">
            <h2 class="information__title">{{ title }}</h2>
            <ng-template #paraList>
                <div class="information__para-point">
                    <p *ngFor="let point of paraPoints">
                        {{point}}
                    </p>
                </div>
            </ng-template>
            <ng-template #bulletList>
                <ul class="information__bullet-list">
                    <li *ngFor="let point of bulletPoints" class="information__bullet-point">
                        <svg class="information__bullet-image" enable-background="new 0 0 128 128" viewBox="0 0 128 128">
                            <g>
                                <circle cx="64" cy="64" r="16"/>
                            </g>
                            <g>
                                <path d="M64,104c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40C104,86.056,86.056,104,64,104z    M64,36c-15.439,0-28,12.561-28,28s12.561,28,28,28s28-12.561,28-28S79.439,36,64,36z"/>
                            </g>
                            <g>
                                <path d="M64,128C28.71,128,0,99.29,0,64C0,28.71,28.71,0,64,0c35.29,0,64,28.71,64,64C128,99.29,99.29,128,64,128z M64,12   c-28.673,0-52,23.327-52,52s23.327,52,52,52s52-23.327,52-52S92.673,12,64,12z"/>
                            </g>
                        </svg>
                        <span>{{ point }}</span>
                    </li>
                </ul>
            </ng-template>
            <ng-template #defaultList>
                <ul class="information__bullet-list">
                    <li *ngFor="let point of defaultBulletPoints" class="information__bullet-point">
                        <svg class="information__bullet-image" enable-background="new 0 0 128 128" viewBox="0 0 128 128">
                            <g>
                                <circle cx="64" cy="64" r="16"/>
                            </g>
                            <g>
                                <path d="M64,104c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40C104,86.056,86.056,104,64,104z    M64,36c-15.439,0-28,12.561-28,28s12.561,28,28,28s28-12.561,28-28S79.439,36,64,36z"/>
                            </g>
                            <g>
                                <path d="M64,128C28.71,128,0,99.29,0,64C0,28.71,28.71,0,64,0c35.29,0,64,28.71,64,64C128,99.29,99.29,128,64,128z M64,12   c-28.673,0-52,23.327-52,52s23.327,52,52,52s52-23.327,52-52S92.673,12,64,12z"/>
                            </g>
                        </svg>
                        <span>{{ point }}</span>
                    </li>
                </ul>
            </ng-template>
            
            <ng-container *ngIf="(bulletPoints?.length ?? 0) > 0 || (paraPoints?.length ?? 0) > 0; else defaultBullets">
                <ng-container *ngIf="!bulletsFirst; else orderBulletFirst">            
                    <ng-container *ngTemplateOutlet="paraList"></ng-container>
                    <ng-container *ngTemplateOutlet="bulletList"></ng-container>            
                </ng-container>
                <ng-template #orderBulletFirst>  
                    <ng-container *ngTemplateOutlet="bulletList"></ng-container>            
                    <ng-container *ngTemplateOutlet="paraList"></ng-container>
                </ng-template>
            </ng-container>
            <ng-template #defaultBullets> 
                <ng-container *ngIf="eventList && eventList.length <= 0">
                    <ng-container *ngTemplateOutlet="defaultList"></ng-container>
                </ng-container>
            </ng-template>

            <!-- event List -->
            <ng-container *ngFor="let event of eventList">
                <h3 class="information__title information__eventitle">{{ event.title }}</h3>
                <div *ngIf="event.paragraphs && event.paragraphs.length > 0" class="information__para-point">
                    <p *ngFor="let point of event.paragraphs">
                        {{point}}
                    </p>
                </div>
                <ul *ngIf="event.bullets && event.bullets.length > 0" class="information__bullet-list">
                    <li *ngFor="let bullet of event.bullets" class="information__bullet-point">
                        <svg class="information__bullet-image" enable-background="new 0 0 128 128" viewBox="0 0 128 128">
                            <g>
                                <circle cx="64" cy="64" r="16"/>
                            </g>
                            <g>
                                <path d="M64,104c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40C104,86.056,86.056,104,64,104z    M64,36c-15.439,0-28,12.561-28,28s12.561,28,28,28s28-12.561,28-28S79.439,36,64,36z"/>
                            </g>
                            <g>
                                <path d="M64,128C28.71,128,0,99.29,0,64C0,28.71,28.71,0,64,0c35.29,0,64,28.71,64,64C128,99.29,99.29,128,64,128z M64,12   c-28.673,0-52,23.327-52,52s23.327,52,52,52s52-23.327,52-52S92.673,12,64,12z"/>
                            </g>
                        </svg>
                        <span>{{ bullet }}</span>
                    </li>
                </ul>
            </ng-container>
           

            <!-- <ng-container *ngIf="bulletsFirst">
                    <ul class="information__bullet-list">
                        <li *ngFor="let point of bulletPoints" class="information__bullet-point">
                            <svg class="information__bullet-image" enable-background="new 0 0 128 128" viewBox="0 0 128 128">
                                <g>
                                    <circle cx="64" cy="64" r="16"/>
                                </g>
                                <g>
                                    <path d="M64,104c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40C104,86.056,86.056,104,64,104z    M64,36c-15.439,0-28,12.561-28,28s12.561,28,28,28s28-12.561,28-28S79.439,36,64,36z"/>
                                </g>
                                <g>
                                    <path d="M64,128C28.71,128,0,99.29,0,64C0,28.71,28.71,0,64,0c35.29,0,64,28.71,64,64C128,99.29,99.29,128,64,128z M64,12   c-28.673,0-52,23.327-52,52s23.327,52,52,52s52-23.327,52-52S92.673,12,64,12z"/>
                                </g>
                            </svg>
                            <span>{{ point }}</span>
                        </li>
                    </ul>
            </ng-container>
           
                <ng-container *ngIf="!bulletsFirst">
                    <div class="information__para-point">
                        <p *ngFor="let point of bulletPoints">
                            {{point}}
                        </p>
                    </div>
                </ng-container> -->
           
            <div class="information__button-wrapper">
                <button [disabled]="ctaDisabled" (click)="register()" class="button button--primary information__button">{{ ctaButtonText }}</button>
            </div>
        </div>
    </div>
</section>